import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"soli-avatar-btn image",class:[
        'avatar-btn px-0 my-1',
        (_vm.$vuetify.breakpoint.width >= 375 && (_vm.avatar || _vm.icon)) ||
        !_vm.autoHideImage
            ? 'justify-start'
            : 'justify-center',
        _vm.disabled ? 'custom-btn' : null,
        _vm.containBtn ? 'contain-btn' : null,
    ],attrs:{"disabled":_vm.trueDisabled,"outlined":_vm.outlined || _vm.active,"block":_vm.block,"loading":_vm.loading,"max-height":_vm.dense ? _vm.size : null,"ripple":_vm.ripple,"inputValue":_vm.active,"text":"","color":_vm.color},nativeOn:{"click":function($event){_vm.$emit('click', $event), _vm.$emit('input', _vm.id)}}},[(
            (_vm.$vuetify.breakpoint.width >= 375 && (_vm.avatar || _vm.icon)) ||
            !_vm.autoHideImage
        )?_c(VListItemAvatar,{class:{
            'blue-avatar-border': _vm.blue,
            'shadow-blue': _vm.blueShadow,
            'mr-6': _vm.largeText,
        },attrs:{"size":_vm.size}},[(_vm.icon)?_c(VIcon,{attrs:{"large":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "),(_vm.avatar)?_c(VImg,{attrs:{"src":_vm.avatar,"size":_vm.size}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"overflow-hidden justify-items-start"},[(_vm.subtitleTop)?_c(VListItemSubtitle,{staticClass:"flex",class:[
                _vm.$vuetify.breakpoint.width < 375 && _vm.autoHideImage
                    ? 'justify-center'
                    : 'justify-start',
                _vm.largeText ? 'subtitle-1' : null,
            ],staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.subtitleTop)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.title)?_c(VListItemTitle,{class:[
                'font-bold align-center normal-case max-w-full',
                _vm.$vuetify.breakpoint.width >= 375 || !_vm.autoHideImage
                    ? 'flex'
                    : null,
                _vm.largeText ? 'text-h6 font-weight-bold short-line' : null,
            ]},[_vm._v(_vm._s(_vm.title)+"\n            "),(_vm.moreInfo)?_c('small',{staticClass:"primary--text flex align-center px-2 underline caption",class:{
                    'justify-start':
                        _vm.$vuetify.breakpoint.width < 375 || !_vm.autoHideImage,
                },staticStyle:{"cursor":"pointer"}},[_vm._v("More Info")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.subtitleBottom)?_c(VListItemSubtitle,{staticClass:"normal-case max-w-full flex",class:[
                _vm.$vuetify.breakpoint.width < 375 && _vm.autoHideImage
                    ? 'justify-center'
                    : 'justify-start',
                _vm.largeText ? 'subtitle-1' : null,
            ]},[_vm._v("\n            "+_vm._s(_vm.subtitleBottom)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.subtitleBottom2)?_c(VListItemSubtitle,{staticClass:"normal-case max-w-full flex",class:_vm.$vuetify.breakpoint.width < 375 && _vm.autoHideImage
                    ? 'justify-center'
                    : 'justify-start'},[_vm._v("\n            "+_vm._s(_vm.subtitleBottom2)+"\n        ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.append)?_c(VIcon,{staticClass:"right-0 px-5",class:{ flip: _vm.value },staticStyle:{"position":"absolute"},attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.append))]):_vm._e()],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }